import * as Yup from "yup";

export const userValidationSchema = Yup.object().shape({
  fullName: Yup.string()
    .min(2, "Введите корректные данные")
    .required("Обязательное поле"),
  contact: Yup.string().required("Обязательное поле"),
  description: Yup.string()
    .min(2, "Введите корректные данные")
    .required("Обязательное поле"),
});
